import React, { useState, useRef, useEffect } from "react";
import { useDomainConfig } from "../hooks/useDomainConfig";

const DomainSelector = ({ className = "", onDomainChange }) => {
  const { selectedDomain, switchDomain, allDomains, isLoading } =
    useDomainConfig();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleDomainChange = (newDomain) => {
    console.log(
      `🔄 DomainSelector: Domain change requested: ${selectedDomain} -> ${newDomain}`
    );

    if (newDomain === selectedDomain) {
      console.log("⚠️ DomainSelector: Same domain selected, no change needed");
      setIsDropdownOpen(false);
      return;
    }

    // Call hook's switchDomain function
    switchDomain(newDomain);

    // Call parent's callback if provided
    if (onDomainChange) {
      console.log("📞 DomainSelector: Calling parent onDomainChange callback");
      onDomainChange(newDomain);
    }

    // Close dropdown after selection
    setIsDropdownOpen(false);
  };

  const toggleDropdown = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Get current domain info
  const currentDomain = allDomains.find(
    (domain) => domain.id === selectedDomain
  );

  if (isLoading) {
    return (
      <div className={`mb-4 ${className}`}>
        <label className="block text-gray-700 font-medium mb-2">
          Lĩnh vực hoạt động
        </label>
        <div className="w-full p-2 border border-gray-300 rounded bg-gray-100 cursor-not-allowed animate-pulse">
          <span className="text-gray-500">Đang tải...</span>
        </div>
      </div>
    );
  }

  console.log("🔍 DomainSelector render:", {
    selectedDomain,
    allDomainsCount: allDomains.length,
    isLoading,
  });

  return (
    <div className={`mb-4 ${className}`}>
      <label className="block text-gray-700 font-medium mb-2">
        Lĩnh vực hoạt động
      </label>
      <div className="relative" ref={dropdownRef}>
        <div className="dropdown mt-2">
          <div
            className="dropdown-button flex items-center justify-between w-full p-2 border border-gray-300 rounded bg-white cursor-pointer"
            onClick={toggleDropdown}
          >
            <span className="text-gray-700">
              {currentDomain
                ? `${currentDomain.icon} ${currentDomain.name}`
                : "Chọn lĩnh vực hoạt động"}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-gray-500"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
        {isDropdownOpen && (
          <div
            className="absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-lg"
            style={{
              transition: "all 0.2s ease-in-out",
              transformOrigin: "top center",
            }}
          >
            <div className="max-h-60 overflow-y-auto dropdown-content">
              {allDomains.map((domain) => (
                <div
                  key={domain.id}
                  className="dropdown-item p-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => handleDomainChange(domain.id)}
                >
                  {domain.icon} {domain.name}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DomainSelector;
